import React, { createContext, useContext, useState, ReactNode } from 'react';
import SupportModal from '../components/SupportModal';

interface SupportContextType {
    openSupport: (category?: string) => void;
    closeSupport: () => void;
}

const SupportContext = createContext<SupportContextType | undefined>(undefined);

export const SupportProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [initialCategory, setInitialCategory] = useState<string | undefined>(undefined);

    const openSupport = (category?: string) => {
        setInitialCategory(category);
        setIsOpen(true);
    };

    React.useEffect(() => {
        (window as any).openSupport = openSupport;
        return () => { delete (window as any).openSupport; };
    }, []);

    const closeSupport = () => {
        setIsOpen(false);
        setInitialCategory(undefined);
    };

    return (
        <SupportContext.Provider value={{ openSupport, closeSupport }}>
            {children}
            <SupportModal
                isOpen={isOpen}
                onClose={closeSupport}
                initialCategory={initialCategory}
            />
        </SupportContext.Provider>
    );
};

export const useSupport = () => {
    const context = useContext(SupportContext);
    if (context === undefined) {
        throw new Error('useSupport must be used within a SupportProvider');
    }
    return context;
};
